<template>
	<div class="content">
		<div class="header flex-row">
			<div class="step-item flex-column" style="color: #ffffff;">
				<img src="../assets/img/icon-category.svg">
				选择预约类型
			</div>
			<div class="step-item flex-column">
				<img src="../assets/img/icon-infoed.svg">
				填写预约信息
			</div>
			<div class="step-item flex-column">
				<img src="../assets/img/icon-ordered.svg">
				确认订单结算
			</div>
			<div class="step-item flex-column">
				<img src="../assets/img/icon-settlemented.svg">
				订单预约成功
			</div>
		</div>
		<div class="section">
			<div class="left-box flex-row">
				<div class="openness">
					<img class="mask" src="../assets/img/img-mask.svg">
					<div class="title">开放时间</div>
					<p>四川大学博物馆全年实行无休，游客可凭 二维码和身份证检票后入馆参观</p>
					<div class="time flex-row">
						<div class="timeInterval flex-column">
							<span>{{openingHours}}</span>
							开放入馆时间
						</div>
						<div class="timeInterval flex-column" v-if="stopCheckTime!=null">
							<span>{{stopCheckTime}}</span>
							停止入馆时间
						</div>
						<div class="timeInterval flex-column">
							<span>{{closingTime}}</span>
							闭馆时间
						</div>
					</div>
					<div class="phone">
						票务咨询电话
						<span>{{contactsPhone}}</span>
					</div>
				</div>
				<div class="detail">

				</div>
			</div>
			<div class="right-box">
				<router-link to="FitReservation">
					<div class="FIT">
						<div class="title">
							散客预约
						</div>
						<span>游园、两馆、候补排队></span>
						<div class="btn">
							立即预约
						</div>
					</div>
				</router-link>
				<router-link to="ReservationInfo">
					<div class="team">
						<div class="title">
							团队预约
						</div>
						<span>须先团队资质认证再购票></span>
						<div class="btn">
							立即预约
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<!-- 提示团队认证弹窗 -->
		<Tips :isShowTips="isShowTips" @changeDialog="getData"></Tips>
	</div>
</template>

<script>
	import Tips from '../components/Dialog/Tips.vue' //团队认证审核中
	import {
		getTicketConfig
	} from '../utils/http.js'
	export default {
		name: 'Category',
		components: {
			Tips
		},
		data() {
			return {
				isShowTips: false,
				contactsPhone: '', //联系电话
				closingTime: '', //闭馆时间
				stopCheckTime: '', //停止入馆时间
				openingHours: '', //开馆时间
				content: '<p>优惠参观</p>年龄6（ 含6周岁） 至18岁（ 不含18周岁） 中国青少年凭有效身份证件；国内全日制统招在读硕士研究生及以下学历学生凭有效身份证件和《 学生证》；年龄60周岁至70周岁以下中国公民（ 含港澳台） 凭有效身份证件。 '
			}
		},
		mounted() {
			this._getTicketConfig("sourceType=2")
		},
		methods: {
			// 获取子组件传过来的值
			getData(val) {
				this.isShowTips = val
			},
			async _getTicketConfig(param) {
				let that = this;
				const res = await getTicketConfig(param);
				if (res.code == 0) {
					that.contactsPhone = res.data.contactsPhone; //联系电话
					that.closingTime = res.data.closingTime; //闭馆时间
					that.stopCheckTime = res.data.stopCheckTime; //停止入馆时间
					that.openingHours = res.data.openingHours; //开馆时间
				}
			}

		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		height: 682px;
		margin: auto;
		background: #FFFFFF;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		border-radius: 6px;
		padding: 24px;
		box-sizing: border-box;
	}

	.header {
		width: 100%;
		height: 70px;
		background-image: url(../assets/img/step1.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding: 0 83px;
		box-sizing: border-box;
		justify-content: space-between;
		margin-bottom: 24px;
	}

	.header .step-item {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BB2916;
	}

	.header .step-item img {
		width: 26px;
		height: 26px;
		margin-bottom: 6px;
	}

	.header .step-item img:first-child {
		width: 30px;
		height: 24px;
	}

	.header .step-item img:last-child {
		width: 26px;
		height: 24px;
	}

	.section {
		width: 1152px;
		height: 540px;
		box-shadow: inset 0px 0px 104px 0px rgba(8, 16, 16, 1);

		background-repeat: no-repeat;
		display: flex;
		flex-direction: row;
		padding-top: 20px;
		box-sizing: border-box;
	}

	.section .left-box {
		width: 852px;
		height: 454px;
		background-image: url(../assets/img/bg1.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-top: 66px;
		padding: 30px 44px;
		box-sizing: border-box;
		justify-content: space-between;
	}

	.section .right-box {
		width: 264px;
		margin-top: 15px;
		margin-left: 23px;
	}

	.right-box .FIT {
		width: 100%;
		height: 226px;
		background-image: url(../assets/img/img-sanke.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-bottom: 17px;
		padding: 16px 18px;
		box-sizing: border-box;
	}

	.right-box .team {
		width: 100%;
		height: 226px;
		background-image: url(../assets/img/img-team.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-bottom: 17px;
		padding: 16px 18px;
		box-sizing: border-box;
	}

	.openness .mask {
		width: 234px;
		height: 248px;
		margin-top: -90px;
		margin-bottom: 10px;
	}

	.openness .title {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		margin-bottom: 14px;
	}

	.openness p {
		display: block;
		width: 204px;
		font-size: 12px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 14px;
		margin-bottom: 20px;
	}

	.openness .time {
		width: 214px;
		height: 68px;
		background-image: url(../assets/img/img-timeBg.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-bottom: 20px;
		justify-content: space-between;
		font-size: 12px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
	}

	.openness .timeInterval span {
		font-size: 18px;
		font-family: Impact-Regular, Impact;
		font-weight: 400;
		color: #FFFFFF;
		margin-bottom: 4px;
	}

	.openness .phone {
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 19px;
	}

	.openness .phone span {
		display: block;
	}

	.right-box .title {
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
		margin-bottom: 30px;
	}

	.right-box span {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #666666;
		margin-bottom: 22px;
		display: block;
	}

	.right-box .btn {
		width: 104px;
		height: 32px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
		border-radius: 16px;
		text-align: center;
		line-height: 32px;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.right-box .FIT .btn {
		background: #BB2916;
	}

	.right-box .team .btn {
		background: #1A4335;
	}
</style>